module.exports = __webpack_public_path__ + "img/parliament-7.7137481d.jpg";